export * from './notify';

export const combineActions = <R, S, F>(request: R, success: S, fail: F) => {
  return { request, success, fail };
};
